import * as Dropzone from 'react-dropzone';
import * as React from 'react';

export interface DropzoneFile {
    lastModified?: number;
    lastModifiedDate?: Date;
    name?: string;
    preview?: string;
    size?: number;
    type?: string;
    webkitRelativePath?: string;
}

interface Props {
    onDrop: (files: any) => any;
    custom_ref?: string;
    width?: string;
    height?: string;
    text?: string;
    disableClick?: boolean;
    flex?: boolean;
    style?: React.CSSProperties;
    imgUrl?: string;
    draftImageHeight?: boolean;
    bubbleCreate?: boolean;
    bubbleEdit?: boolean;
}

const styles = {
    draftStyle: {
        margin: 'auto',
        padding: '4px',
        objectFit: 'contain',
        width: '50px',
        height: 'fit-content',
    },
    imageHeightAuto: {
        margin: 'auto',
        padding: '4px',
        objectFit: 'contain',
        width: '50px',
        height: 'auto',
    },
    bubbleCreateStyle: {
        margin: 'auto',
        width: '116px',
        height: '130px',
        padding: '3px',
        objectFit: 'contain',
    },
    bubbleEditStyle: {
        margin: 'auto',
        width: '150px',
        height: '168.1px',
        padding: '3px',
        objectFit: 'contain',
    },
};

export class ImageDropzone extends React.Component<Props, {}> {
    render() {
        const {
            onDrop,
            width,
            height,
            imgUrl,
            style,
            custom_ref,
            disableClick,
            flex,
            text,
            bubbleCreate,
            bubbleEdit,
            draftImageHeight,
        } = this.props;
        return (
            <Dropzone
                onDrop={onDrop}
                ref={custom_ref}
                multiple={false}
                style={{
                    width: width ? width : '100%',
                    height: height ? height : '100%',
                    border: '2px dashed rgb(102, 102, 102)',
                    ...style,
                }}
                accept={'image/*'}
                disableClick={disableClick}
            >
                <div className="text-center" style={{ verticalAlign: 'center' }}>
                    <div style={flex ? { display: 'inline-flex' } : null}>
                        {text ? (
                            <div style={{ margin: 'auto' }}>{text}</div>
                        ) : (
                                <img
                                    src={imgUrl ? imgUrl : '../../assets/images/no_img.png'}
                                    style={
                                        bubbleCreate
                                            ? styles.bubbleCreateStyle
                                            : bubbleEdit
                                                ? styles.bubbleEditStyle
                                                : draftImageHeight
                                                    ? styles.imageHeightAuto
                                                    : styles.draftStyle
                                    }
                                />
                            )}
                    </div>
                </div>
            </Dropzone>
        );
    }
}

export default ImageDropzone;



// WEBPACK FOOTER //
// ./src/components/ImageDropzone.tsx